import { Ng2StateDeclaration, StatesModule } from '@uirouter/angular';
import { FiRoleListState } from '@fi-app/role/states/role-list-state';
import { FiRoleAddState } from '@fi-app/role/states/role-add-state';
import { FiRoleViewState } from '@fi-app/role/states/role-view-state';
import { FiRoleEditState } from '@fi-app/role/states/role-edit-state';
import { FiRoleRelationsState } from '@fi-app/role/states/role-relations-state';
import { FiRoleShareContentState } from '@fi-app/role/states/role-share-content';
import { FiAbstractStateComponent } from '@fi-shared/fi-state-proxy/fi-abstract-state.component';
import { StateAccessCheckService } from '@fi-shared/fi-shared-services/state-access-check.service';
import { AccessRightType, ApplicationSettingsType, ObjectTypes } from '@fi-shared/types';
import { FiStateNames } from '@fi-shared/fi-state-proxy/fi-state-names';

const FiRoleState: Ng2StateDeclaration = {
    name: FiStateNames.Role._name,
    url: '/Role',
    abstract: true,
    parent: FiStateNames.GlobalSettings,
    component: FiAbstractStateComponent,
};

export const FiRoleStates: StatesModule = {
    states: [
        FiRoleState,
        FiRoleListState,
        FiRoleAddState,
        FiRoleViewState,
        FiRoleEditState,
        FiRoleRelationsState,
        FiRoleShareContentState,
    ],
};

export function registerRoleStateRules(stateAccessCheckService: StateAccessCheckService) {
    stateAccessCheckService.registerStateRules(
        [FiStateNames.Role.List, FiStateNames.Role.View, FiStateNames.Role.Edit],
        {
            SettingType: [ApplicationSettingsType.CoreGlobal],
            AccessType: AccessRightType.Admin,
        },
    );

    stateAccessCheckService.registerStateObjectType([FiStateNames.Role.View, FiStateNames.Role.Edit], ObjectTypes.Role);
}
